import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47f01c52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pl-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Select a Protocol:")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "flex xs1" }
const _hoisted_6 = {
  key: 0,
  class: "flex row pt-2"
}
const _hoisted_7 = { class: "flex xs12 sm8 md6" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Vote for this Protocol!")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" This protocol has not joined up with Notifi yet. Click to Vote and help encourage them to enroll their Contract Events! ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Vote")
const _hoisted_11 = { class: "row pt-2" }
const _hoisted_12 = { class: "row pt-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex sm-3" }, null, -1))
const _hoisted_14 = { class: "flex sm-9 mb-2 justify-self--end" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Activity:")
const _hoisted_16 = ["innerHTML"]

import { computed, ref, watch } from "vue";

import { Subscription } from "@/models/Subscription";
import { Protocol } from "@/models/Protocol";
import { ContractActivity } from "@/models/ContractActivity";

import { Contract } from "@/models/Contract";
import ProtocolSelector from "./ProtocolSelector.vue";
import ProtocolInfo from "./ProtocolInfo.vue";
import { useRoute } from "vue-router";
import { useContractsStore } from "@/store/pinia_contracts";

/* global defineProps  defineEmits */

export default /*#__PURE__*/_defineComponent({
  props: {
  subscription: { type: Subscription, required: false },
  protocol: { type: Protocol, required: false },
  subscriptionID: { type: String, required: false },
},
  emits: ["changed"],
  async setup(__props, { expose, emit }) {

let __temp: any, __restore: any

const props = __props



const route = useRoute();

const fetchBySubscriptionID = async (subID: string): Promise<Subscription> => {
  const sub = await Subscription.fetch(subID);
  if (sub) {
    activeSubscription.value = sub;
    const prot: Protocol = sub.protocol;
    await prot.fetch();
    selectedProtocol.value = prot;
    contractID.value = sub.contract.id;
    contractActivityID.value = sub.contractActivity.id;
    await fetchContractActivities();
    fetching.value = false;
    return sub;
  }
  throw "Invalid Subscription ID";
};

const fetching = ref(false);
const activeSubscription = ref<Subscription>();

const contractID = ref<string | undefined>();
const contractActivityID = ref<string | undefined>();
const intSelectedProtocol = ref<Protocol | undefined>(props.protocol);

const contractActivities = ref<Array<ContractActivity>>([]);

const clearProtocol = () => {
  selectedProtocol.value = undefined;
};
const selectProtocol = (prot: Protocol) => {
  selectedProtocol.value = prot;
};
const selectedProtocol = computed({
  get(): Protocol | undefined {
    return intSelectedProtocol.value;
  },
  set(val: Protocol | undefined) {
    intSelectedProtocol.value = val;
  },
});
const voteFor = async (): Promise<void> => {
  if (!selectedProtocol.value) return undefined;
  await selectedProtocol.value.siteVote();
  //this.$forceUpdate();
};

watch(selectedProtocol, (): void => {
  fetchContracts();
});

watch(contractID, () => {
  fetchContractActivities();
});

const selectedContract = computed((): Contract | undefined => {
  return contracts.value?.find((e) => e.id == contractID.value);
});

const selectedContractActivity = computed((): ContractActivity | undefined => {
  const ca = contractActivities.value.find(
    (e) => e.id == contractActivityID.value
  );
  if (!ca) return undefined;
  return ca;
});

const activityDescription = computed((): string => {
  const act = selectedContractActivity.value;
  if (!act) return "";
  let res = act.description;
  if (!activityAllowed.value) {
    const prot = selectedProtocol.value;
    const actTokens = prot?.goldQuantity;
    const symbol = prot?.symbol;
    const bal = prot?.getWalletBalance();
    res =
      res +
      `<br/><br/>Warning: Requires protocol level <strong>${act.level}</strong>.  Stake at least ${actTokens} tokens in ${symbol} to subscribe to this activity. Your wallet holds ${bal}`;
  }
  return res;
});

// True if the current user is allowed to subscribe to the selected ContractActivity
const activityAllowed = computed((): boolean => {
  const act = selectedContractActivity.value;
  const prot = selectedProtocol.value;
  if (!prot || !act) {
    return false;
  }
  return prot.userSubscriptionAllowed(act);
});

const validContract = computed((): boolean => {
  return true;
});
const protocolNoContracts = computed((): boolean => {
  if (selectedProtocol.value) return contracts.value.length == 0;
  return false;
});

const showCompletion = computed((): boolean => {
  return selectedProtocol.value != undefined && contracts.value.length > 0;
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const canComplete = computed((): boolean => {
  return selectedProtocol.value != undefined && contracts.value.length > 0;
});

const contracts = ref<Contract[]>();

const validSubmit = computed((): boolean => {
  return validContractSubmit.value;
});

const validContractSubmit = computed((): boolean => {
  return (
    selectedContract.value != undefined &&
    selectedContractActivity.value != undefined &&
    activityAllowed.value
  );
});

const message = computed((): string => {
  let msg = "";
  if (selectedProtocol.value) {
    msg = `the <strong>${selectedProtocol.value.name} Protocol</strong>`;
  }
  msg = `${msg} which trigger on`;
  if (selectedContractActivity.value?.type == "Transaction") {
    msg = `${msg} <strong>Transactions</strong>`;
  } else {
    msg = `${msg} <strong>${selectedContractActivity.value?.name}</strong>`;
  }
  if (selectedContract.value) {
    msg = `${msg} for the contract <strong>${selectedContract.value.description}</strong>`;
    msg = `${msg} on the <strong>${selectedContract.value.chain} blockchain</strong>`;
  }
  return msg;
});

const fetchContracts = async (): Promise<void> => {
  let res: Contract[] = [];
  const contractsStore = useContractsStore();
  let curFound = false;
  if (selectedProtocol.value) {
    res = await contractsStore.getProtocolContracts(selectedProtocol.value);
    for (let i = 0; i < res.length; i = i + 1) {
      if (res[i].id == contractID.value) curFound = true;
    }
  }
  if (!curFound) contractID.value = undefined;
  contracts.value = res;
  fetchContractActivities();
};

const fetchContractActivities = async (): Promise<void> => {
  const res: ContractActivity[] = [];
  const ci = selectedContract.value;
  let curFound = false;
  if (ci) {
    const actsRel = ci.relation("ContractActivities");
    const acts: ContractActivity[] = await actsRel.query().find();
    for (let i = 0; i < acts.length; i = i + 1) {
      res.push(acts[i]);
      if (acts[i].id == contractActivityID.value) curFound = true;
    }
  }
  if (!curFound) contractActivityID.value = undefined;
  contractActivities.value = res;
};


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const irrigate = (s: Subscription): void => {
  if (selectedProtocol.value != undefined) {
    s.protocol = selectedProtocol.value;
  }
  if (selectedContract.value) {
    s.set("contract", selectedContract.value);
    s.set("contractAddress", selectedContract.value.address);
    s.set("contractChain", selectedContract.value.get("chain"));
  }
  if (selectedContractActivity.value) {
    s.set("contractActivity", selectedContractActivity.value);
  }
};

if (route.query.protocolID) {
  fetching.value = true;
  selectedProtocol.value = (
  ([__temp,__restore] = _withAsyncContext(() => Protocol.fetch(
    route.query.protocolID as string
  ))),
  __temp = await __temp,
  __restore(),
  __temp
);
}

if (props.subscriptionID) {
  (
  ([__temp,__restore] = _withAsyncContext(() => fetchBySubscriptionID(props.subscriptionID))),
  await __temp,
  __restore()
);
}

// eslint-disable-next-line no-undef
expose({ irrigate, message, validSubmit, canComplete });

if (props.subscriptionID) {
  (
  ([__temp,__restore] = _withAsyncContext(() => fetchBySubscriptionID(props.subscriptionID))),
  await __temp,
  __restore()
);
}


return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_alert = _resolveComponent("va-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(ProtocolSelector, {
          showSearch: true,
          showUserInfo: true,
          onSelection: selectProtocol
        })
      ], 512), [
        [_vShow, !_unref(selectedProtocol)]
      ]),
      (_unref(selectedProtocol))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(ProtocolInfo, {
              protocol: _unref(selectedProtocol),
              selected: false,
              showVote: false,
              showUserInfo: true,
              showFavorites: true,
              allowSelect: false,
              showSubscribe: false,
              displayMode: "narrow"
            }, null, 8, ["protocol"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_va_button, {
                onClick: clearProtocol,
                size: "small",
                color: "secondary",
                icon: "clear",
                class: "float-right"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_va_divider, { inset: "" }),
    (_unref(protocolNoContracts))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_card, { bordered: false }, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_title, null, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_card_content, null, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_popover, {
                      color: "primary",
                      message: "Request support for this Protocol on Notifi"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_button, {
                          size: "large",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (voteFor(__props.protocol)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_va_select, {
          class: "flex sm6",
          label: "Contract Name",
          modelValue: contractID.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contractID).value = $event)),
          options: contracts.value,
          "track-by": (option) => option.id,
          "value-by": "id",
          "text-by": "description",
          searchable: "",
          rules: [_unref(validContract) || 'Select a contract']
        }, null, 8, ["modelValue", "options", "track-by", "rules"]),
        _createVNode(_component_va_select, {
          class: "flex sm4",
          label: "Contract Activity",
          modelValue: contractActivityID.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contractActivityID).value = $event)),
          options: contractActivities.value,
          "track-by": "id",
          "value-by": "id",
          "text-by": (option) => option.nameAndLevel,
          searchable: ""
        }, null, 8, ["modelValue", "options", "text-by"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_va_alert, {
            "border-color": _unref(activityAllowed) ? 'success' : 'danger',
            border: "top"
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_va_icon, {
                name: _unref(activityAllowed) ? 'psychology' : 'error',
                color: _unref(activityAllowed) ? 'info' : 'danger'
              }, null, 8, ["name", "color"])
            ]),
            title: _withCtx(() => [
              _hoisted_15
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _unref(activityDescription) }, null, 8, _hoisted_16)
            ]),
            _: 1
          }, 8, ["border-color"])
        ])
      ])
    ], 512), [
      [_vShow, _unref(showCompletion)]
    ])
  ], 64))
}
}

})